/* global axios */
import ApiClient from '../ApiClient';

// Teletel-owned CSV export of CSAT review notes.
//
// The stock CSAT download keeps its Enterprise-gated behaviour untouched; this
// is the independent path. The endpoint answers with a CSV body rather than
// JSON, so the response is taken as text and handed to downloadCsvFile.
class TeletelCsatReviewNotesAPI extends ApiClient {
  constructor() {
    super('csat-review-notes', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  // `since` and `until` are optional epoch seconds; the controller filters on
  // created_at when they are present.
  download({ since, until } = {}) {
    const params = {};
    if (since) params.since = since;
    if (until) params.until = until;
    return axios.get(this.url, { params, responseType: 'text' });
  }
}

export default new TeletelCsatReviewNotesAPI();
